// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__beD-k","title":"Info_title__3wBWa","links":"Info_links__2LtVJ","link":"Info_link__eKeug","logo":"Info_logo__1U_Pp"};